<template>
  <el-select
    v-model="model.inventory"
    filterable
    :disabled="disabled"
    clearable
    :multiple="multiple"
    value-key="id"
    :loading="loading"
    :placeholder="$t('common.select.placeholder')"
    @change="selectInventory">
    <el-option
      v-for="inventory in inventories"
      :key="inventory.id"
      :label="inventory.name"
      :value="inventory">
    </el-option>
  </el-select>
</template>
<script>
import { mapActions, mapState, mapGetters } from 'vuex';
export default {
	name: 'SelectInventory',
  props: {
		selectedInventory : {
      type : Object
    },
    selectedInventories: {
      type: Array,
      default: () => [],
    },
    disabled: {
      type: Boolean,
      default: false
    },
    multiple: {
      type: Boolean,
      default: false
    },
	},
	data() {
		return {
      model : {
        inventory : null
      },
      loading : false
	   }
   },
  computed: {
    ...mapState('inventory',['inventories']),
    ...mapGetters('inventory', ['defaultInventory'])
  },
  components : {
  },
  methods : {
    selectInventory(inventory){
      this.$emit('selected', inventory);
    },
    getInventoryById(inventoryId){
      return _.find(this.inventories, inv => inv.id === inventoryId);
    },
    ...mapActions('inventory', ['fetchInventories'])
  },
  watch: {
    selectedInventory: function(inventory) {

      this.model.inventory = inventory;

    },
    selectedInventories: function(inventories) {

      this.model.inventory = inventories;

    }
  },
  created(){
    this.fetchInventories();
    if (this.selectedInventory != null) {
      this.model.inventory = this.selectedInventory;
    } else if(this.selectedInventories != null) {
      this.model.inventory = this.selectedInventories;
    } else {
      this.model.inventory = this.defaultInventory;
      this.selectInventory(this.defaultInventory);
    }
  }
}
</script>
<style lang="scss" scoped>

</style>
